import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { environment } from "@environments/environment";

let numInstances = 0;

@Component({
    selector: "app-text-box",
    templateUrl: "./text-box.component.html",
    styleUrls: ["./text-box.component.scss"],
    standalone: false
})
export class textBoxComponent implements OnInit {
  private instanceId: number;

  constructor(private fb: UntypedFormBuilder) {
    this.instanceId = numInstances++;
  }

  @Input() data: any = [];
  @Input() type?: string;
  @Input() position?: any;
  @Input() preview?: boolean;
  @Input() hasEdit?: boolean = true;
  @Input() canvasMode!: any;

  @Output() chartTextChange = new EventEmitter<any>();
  public textForm!: UntypedFormGroup;
  public apiTinymce: any = environment.apiTinymce;
  public divID = "myToolbar";
  private apiToken = sessionStorage.getItem("TOKEN");

  public imageOptions: any = {
    height: 100,
    menubar: false,
    inline: true,
    resize: false,
    image_advtab: false,
    images_upload_handler: this.imagesUploadHandler,
    placeholder: "Click in to add an image to this section.",
    branding: false,
    toolbar_mode: "sliding",
    plugins: "image",
    toolbar: "image | alignleft aligncenter alignright | undo redo",
    automatic_uploads: true,
    setup: function (this: any, editor: any) {
      editor.on("focus", function (this: any, e: any) {
        if (this.getContent() == "")
          setTimeout(() => this.execCommand("mceImage"), 500);
      });
    },

    fixed_toolbar_container: "#" + this.divID,
  };
  public headerOptions: any = {
    height: 100,
    menubar: false,
    inline: true,
    resize: false,
    placeholder: "Click in to add text to this section.",
    branding: false,
    toolbar_mode: "sliding",
    plugins:
      "importcss searchreplace autolink autosave save directionality code visualblocks visualchars  link  codesample table charmap  pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools  help charmap  emoticons",
    toolbar:
      "undo redo | bold italic underline strikethrough |  fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | table| outdent indent |  forecolor backcolor removeformat  | insertfile  link  |help",
    contextmenu: "link table",
    fixed_toolbar_container: "#" + this.divID,
  };
  public optionsTinymce: any = {
    height: 100,
    menubar: false,
    inline: true,
    resize: false,
    placeholder: "Click in to add text, tables, etc to this section.",
    branding: false,
    toolbar_mode: "sliding",
    plugins:
      " importcss searchreplace autolink autosave save directionality code visualblocks visualchars  link  codesample table charmap  pagebreak nonbreaking anchor insertdatetime advlist lists wordcount  help charmap",
    toolbar:
      "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat  |table| charmap  |insertfile  link   |help",

    contextmenu: "link table",
    fixed_toolbar_container: "#" + this.divID,
  };

  imagesUploadHandler(blobInfo: any, success: any, failure: any) {
    let xhr = new XMLHttpRequest();
    xhr.open("POST", environment.enterpriseUrls.apiEndpoint + "/images");
    xhr.setRequestHeader(
      "Authorization",
      `Bearer ${sessionStorage.getItem("TOKEN")}`
    ); // manually set header
    const buildName = sessionStorage.getItem("BUILDNAME") || "";
    xhr.setRequestHeader("build", buildName); // manually set header

    xhr.onload = function () {
      if (xhr.status !== 200) {
        failure("HTTP Error: " + xhr.status);
        return;
      }

      let json = JSON.parse(xhr.responseText);

      if (!json || typeof json.location !== "string") {
        failure("Invalid JSON: " + xhr.responseText);
        return;
      }

      success(json.location);
    };

    let formData = new FormData();
    formData.append("file", blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
  }

  handleEvent(event: any) {
    this.chartTextChange.emit({
      position: this.position,
      value: this.textForm.controls["text"].value,
    });
  }

  initForm() {
    this.textForm = this.fb.group({
      text: new UntypedFormControl(this.data),
    });
  }

  ngOnInit(): void {
    this.initForm();
    if (this.type == "image") {
      this.optionsTinymce = this.imageOptions;
    }
    if (this.type == "header" || this.type == "footer") {
      this.optionsTinymce = this.headerOptions;
    }
    this.divID = "myToolbar" + this.instanceId;
    (this.optionsTinymce.fixed_toolbar_container = "#" + this.divID),
      +this.instanceId;
  }
}
